// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { P } from '../Typography';

type Sidecontent = {
  main: string,
  secondary?: Array<string>,
}

export type Rule = {
  color: string,
  ruleNum: number,
  inDetail?: string,
  content: string,
  sideContent: Array<Sidecontent>,
  sideIsFlex?: boolean,
}

const FAQRule = ({
  // eslint-disable-next-line no-unused-vars
  color, ruleNum, content, sideContent, inDetail, sideIsFlex,
}: Rule) => {
  const { t } = useTranslation();
  return (
    <section className={styles.faqRuleWrapper}>
      <div className={styles.faqRule}>
        <div
          className={styles.ruleNumber}
          style={{
            background: color,
            color: (color === '#0B07FF' || color === '#000000' || color === '#C31AFF') ? 'white' : 'black',
          }}
        >
          {t(ruleNum)}
        </div>
      </div>
      <div className={styles.sideContent}>
        <section className={styles.ruleWrapper}>
          <P>
            {t(content)}
            {inDetail
            && (
            <Link className={styles.ruleLink} to={inDetail}>
              *
              {t('moreDetails')}
            </Link>
            )}
          </P>
        </section>
        <div className={`${sideIsFlex ? styles.flexSide : ''}`}>
          {sideContent.map((item) => (
            <section
              key={item.main}
            >
              <P
                className={styles.sideContentWeak}
                transparency="weaker"
              >
                {t(item.main)}
              </P>
              {(item.secondary && item.secondary.length) && (
                <section className={styles.secondaryRulesBlock}>
                  {item.secondary.map((secItem) => (
                    <P
                      key={secItem}
                      className={styles.sideContentWeak}
                      transparency="weaker"
                    >
                      {t(secItem)}
                    </P>
                  ))}
                </section>
              )}
            </section>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQRule;
